import { ProductItemPreviewProps } from 'store/product/types';

export const gtmRecentlyViewedEvent = (product: ProductItemPreviewProps, url: string) => ({
  event: 'recentlyViewed',
  ecommerce: {
    detail: {
      actionField: {
        action: 'detail',
        url,
      },
      product,
    },
  },
});

export default gtmRecentlyViewedEvent;
